<template>
  <span>
    <span
      :style="{
        height: iconSize + 'px',
        width: iconSize + 'px',
        backgroundImage: `url(${require(`@/assets/icons/${icon}.svg`)})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100%'
      }"
    ></span>
    <a
      :style="{
        color: color,
        fontSize: fontSize + 'px',
        margin
      }"
      >{{ title }}</a
    >
  </span>
</template>

<script>
export default {
  name: 'IconLink',
  props: {
    title: {},
    color: { default: '#c6c6c6' },
    fontSize: { default: 14 },
    margin: {},
    icon: { required: true },
    iconSize: { default: '24' }
  },
  data: function() {
    return {};
  }
};
</script>

<style scoped>
span {
  display: inline-block;
  vertical-align: middle;
}
a {
  cursor: pointer;
  text-decoration: underline;
}
</style>
